import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import styles from '../../../styles/Course.module.scss';
import TrackingResultAssignment from '../Unit/components/Content/Complete/AssigmentComplete/TrackingResultAssignment';
import { LIMIT_GET_LIST, USER_ROLES } from '../../../constants/constants';
import unitsApi from '../../../api/unitsApi';
import { handleToastError } from '../../../helpers';
import useI18n from '../../../hooks/use-i18n';
import { INIT_DATA } from '../../../constants/default';
import { useViewMode } from 'hooks';

const ModalHistory = (props) => {
  const { open, submission, toggle, type, assignment, getSubmissions } = props;
  const i18n = useI18n();
  const viewMode = useViewMode();
  const [isBusy, setBusy] = useState(true);
  const [resultTracking, setResultTracking] = useState(INIT_DATA);

  async function getTrackingResult(page = 1, text = '') {
    try {
      if (submission?.unit || submission?.unitId) {
        const params = {
          id: submission?.unit || submission?.unitId,
          user:
            submission?.user?.[0]?._id ||
            submission?.userId ||
            submission?.user,
          page,
          limit: LIMIT_GET_LIST,
        };
        const response = await unitsApi.getTrackingResult(params);
        setResultTracking(response);
        setBusy(false);
      }
    } catch (error) {
      handleToastError(error, i18n);
    }
  }
  useEffect(() => {
    if (submission?._id || submission?.Id) {
      getTrackingResult();
    }
  }, [submission?._id, submission?.Id]);

  return (
    <Modal isOpen={open} toggle={toggle} className="modal-dialog-top" size="xl">
      <ModalHeader
        className={styles['modal-grade-submission__header']}
        toggle={toggle}
      >
        <div className="flexRow justify-space-between align-items-center">
          <span className="sub-heading_text_title">History</span>
        </div>
      </ModalHeader>
      <ModalBody>
        <TrackingResultAssignment
          showOnLoading
          isBusy={isBusy}
          tracking={resultTracking}
          fetchData={getTrackingResult}
          getSubmissions={getSubmissions}
          deleted={getTrackingResult}
          type={type}
          assignment={assignment}
        />
      </ModalBody>
    </Modal>
  );
};

export default ModalHistory;
